// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timePicker h2, .timePicker h4 {
  text-align: center;
  font-family: var(--font-family);
  font-weight: bold;
}
.timePicker h4 {
  margin-bottom: 0;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: unset;
}
.timePicker h2 {
  color: var(--default-color);
  margin-top: 5px;
  font-size: 20px;
  letter-spacing: unset;
}`, "",{"version":3,"sources":["webpack://./js/vueComponents/timePicker/src/timePicker.vue","webpack://./timePicker.vue"],"names":[],"mappings":"AAEE;EACE,kBAAA;EACA,+BAAA;EACA,iBAAA;ACDJ;ADGE;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;ACDJ;ADGE;EACE,2BAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;ACDJ","sourcesContent":["\n.timePicker {\n  h2, h4 {\n    text-align: center;\n    font-family: var(--font-family);\n    font-weight: bold;\n  }\n  h4 {\n    margin-bottom: 0;\n    font-size: 12px;\n    text-transform: uppercase;\n    letter-spacing: unset;\n  }\n  h2 {\n    color: var(--default-color);\n    margin-top: 5px;\n    font-size: 20px;\n    letter-spacing: unset;\n  }\n}\n",".timePicker h2, .timePicker h4 {\n  text-align: center;\n  font-family: var(--font-family);\n  font-weight: bold;\n}\n.timePicker h4 {\n  margin-bottom: 0;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: unset;\n}\n.timePicker h2 {\n  color: var(--default-color);\n  margin-top: 5px;\n  font-size: 20px;\n  letter-spacing: unset;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
